<template>
  <div class="modal-popup">
    <div class="modal fade" id="createRefundModal" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="booking != null">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">İade Kaydı Oluştur</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">Iade Tutarı</label>
                      <input class="form-control" v-model="paymentRefund.amount" id="refundAmount" type="number" placeholder="">
                    </div>
                    <div class="input-box">
                      <label class="label-text">Iade Sebebi</label>
                      <input class="form-control" v-model="paymentRefund.reason" id="refundReason" type="text" placeholder="">
                    </div>

                  </div>
                  <div class="col-sm-6">
<!--                    <div class="input-box">-->
<!--                      <label class="label-text">Iade Sebebi</label>-->
<!--                      <input class="form-control" v-model="" id="fullAmount" type="checkbox" placeholder="">-->
<!--                    </div>-->
<!--                    <div class="input-box">-->
<!--                      <label class="label-text">Acente</label>-->
<!--                      <div class="form-group">-->
<!--                        <select v-model="paymentRefund.agentId" id="selectedAgency" class="select-contain-select" type="text" placeholder="">-->
<!--                          <option v-for="agency in agencyList" :value="agency.id" style="color: black;"> {{agency.name}} </option>-->
<!--                        </select>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="input-box">
                      <label class="label-text">İade Türü</label>
                      <div class="form-group">
                        <select v-model="paymentRefund.type" id="refundType" class="select-contain-select" type="text" placeholder="">
                          <option value="CASH" style="color: black;"> Nakit </option>
                          <option value="CREDIT_CARD" style="color: black;"> Kredi Kartı </option>
                          <option value="COUPON" style="color: black;"> KUPON </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>
            <button @click="setRemainingToAmount" type="button" class="theme-btn theme-btn-small">Kalan Tutarı İade Et</button>
            <button @click="accept" type="button" class="theme-btn theme-btn-small">Onaylıyorum</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateRefundPopup",
  data:function (){
    return{
      paymentRefund: {amount:0}
    }
  },
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList
      }
    },
    booking:{
      get(){
        return this.$store.getters.getBooking
      }
    },
    checkBookingPayments:{
      get(){
        return this.$store.getters.getCheckBookingPayments
      }
    },
  },
  methods:{
    setRemainingToAmount(){
      this.paymentRefund.amount = this.checkBookingPayments.refundAmount;
    },
    accept(){
      if(this.paymentRefund.amount != null &&
          this.paymentRefund.reason != null){
        this.paymentRefund.bookingId = this.booking.id
        this.paymentRefund.agentId = this.$store.getters.getUser.id;

        this.$store.dispatch("createRefund",this.paymentRefund).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
          window.location.reload();
        })
      }else{
        $("#selectedAgency").addClass("error");
        $("#refundAmount").addClass("error");
        $("#refundReason").addClass("error");
      }

    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

</style>